<template>
  <main v-if="news">
    <h1 style="direction: ltr">{{ news.title }}</h1>

    <section id="article">
      <div id="content" v-html="news.content"/>
      <image-thumbnail :image-name="news.file.name" v-if="news.file && news.file.type === 'image'"/>
    </section>
  </main>
</template>

<script>

import NewsService from '../services/news';
import ImageThumbnail from "../components/ui/imageThumbnail";

export default {
  name: "ReadView",
  props: ['link'],
  components: {ImageThumbnail},
  data() {
    return {
      news: null,
    }
  },
  watch: {
    link() {
      this.getNewsArticle();
    }
  },
  methods: {
    async getNewsArticle() {

      // const link = this.$route.params.link;
      this.news = await NewsService.readNews({link: this.link.replace('/','')});
    }
  },
  beforeMount() {
    this.getNewsArticle()
  }
}
</script>

<style scoped lang="scss">

#article {
  padding: 1rem;
  direction: ltr !important;
  background: var(--articleBgColor);
  margin: 0 1rem;
  border-radius: 8px;

  #content a {
    display: inline-block;
    max-width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: normal;
  }

  * {
    direction: ltr !important;
  }

  * + * {
    direction: ltr !important;
  }

  font-size: 18px;
  text-align: left;
  line-height: 32px;
}



html[data-theme='dark'] {
  #article:deep {

    .insidersReport {
      margin: 0;
      font-weight: 600;
      font-size: 18px;
    }

    .articleTable {
      white-space: nowrap;
      overflow-x: auto;
      table {
        cellspacing: 0;
        cellpadding: 0;
        width: 100%;
      }
      td,tr{
        p,span,div, b,em,strong{
          margin: 0;
          padding: 0;
        }
      }

      tr:hover{
        background: var(--tableHoverColor);
      }

      td{
        border-bottom: 1px solid var(--tableBorderColor);
      }
    }

    a {
      color: var(--lightYellow) !important;
      display: inline-block;
      max-width: 100%;
      overflow-wrap: break-word;
      word-break: break-word;
      white-space: normal;
    }

    * {
      a {
        color: var(--lightYellow) !important;
      }
    }

    a, span, li, p{
      font-weight: 500;
    }

    hr {
      border: 2px solid var(--notficationBorderColor);
    }

    p,li{
      line-height: 28px;
    }

    li:not(:last-of-type) {
      margin-bottom: .5rem;
    }
    p {
      font-weight: 400;
      img {
        max-width: 100%;
      }

      table {
        width: 100%;
      }
      a {
        color: var(--lightYellow) !important;
      }
    }
  }
}

h1 {
  font-size: 22px;
  padding: 0 0 0 1rem;
  line-height: 32px;
}
</style>
